import { ATLAS_AGENT_NAME, isAtlasAgentId } from '@core/constant/atlasAgent';
import { ATLAS_CODER_NAME, isAtlasCoderId } from '@core/constant/atlasCoder';
import { isAtlasNewId } from '@core/constant/atlasNew';
import { ATLAS_SYSTEM_NAME, isAtlasSystemId } from '@core/constant/atlasSystem';
import { CODEX_BOT_NAME, isCodexBotId } from '@core/constant/codexAgent';
import { CURSOR_BOT_NAME, isCursorBotId } from '@core/constant/cursorAgent';

/**
 * Display name for a first-party bot (bare UUID or `bot|<uuid>`), resolved
 * from constants so it never waits on the bots list. Undefined for team bots.
 */
export function firstPartyBotName(id: string): string | undefined {
  // Both Atlas bots present as "Atlas": the chat reply and the agent session
  // are the same persona to a reader, only a different id on the wire.
  if (isAtlasAgentId(id) || isAtlasNewId(id)) return ATLAS_AGENT_NAME;
  if (isAtlasCoderId(id)) return ATLAS_CODER_NAME;
  if (isCodexBotId(id)) return CODEX_BOT_NAME;
  if (isCursorBotId(id)) return CURSOR_BOT_NAME;
  if (isAtlasSystemId(id)) return ATLAS_SYSTEM_NAME;
  return undefined;
}
